import React, { useState } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '~/lib/ui/dialog'
import EditCandidateForm from './EditCandidateForm'
import { useCandidate } from './CandidateProvider'

const EditCandidateDialog = ({ children }) => {
  const [open, setOpen] = useState(false)
  const { candidate } = useCandidate()

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="mt-4 text-intoo-blue-medium underline">
          {children || 'Edit Candidate Info'}
        </button>
      </DialogTrigger>
      <DialogContent
        className="font-roboto lg:max-w-3xl xl:max-w-5xl"
        variant="default"
        dialogCloseClass="text-black"
      >
        <DialogHeader>
          <DialogTitle className="text-left text-2xl">
            Edit {candidate?.fullName}
          </DialogTitle>
        </DialogHeader>
        <div className="px-4 pb-4">
          <EditCandidateForm
            candidate={candidate}
            onClose={() => setOpen(false)}
          />
        </div>
      </DialogContent>
    </Dialog>
  )
}

export default EditCandidateDialog
